//? GETTER CONSTANT
export const getters = {
  // TODO: GET CONSTANT DECLARATION
  GET_APP_BAR: "GET_APP_BAR",
  GET_COM_CODE_LIST: "GET_COM_CODE_LIST",
  GET_COM_USER_INFO: "GET_COM_USER_INFO", //* 사용자정보 데이터가져오기
  GET_ROLE_LIST: "GET_ROLE_LIST",
  GET_SELECTED_DEPARTMENT_MANAGER_DATA: "GET_SELECTED_DEPARTMENT_MANAGER_DATA", //* 선택한 담당부서/담당자 데이터 가져오기
  GET_SELECTED_DEPARTMENT_MANAGER_LIST: "GET_SELECTED_DEPARTMENT_MANAGER_LIST", //* 선택한 담당부서/담당자 데이터(다중) 가져오기
  GET_DEPARTMENT_MANAGER_LIST: "GET_DEPARTMENT_MANAGER_LIST", //* 담당자/담당부서 리스트 가져오기
  GET_VIEWS_DEPT_MANAGER_SINGLE_POP: "GET_VIEWS_DEPT_MANAGER_SINGLE_POP", //* 담당부서/담당자 팝업 ON/OFF 가져오기
  GET_VIEWS_DEPT_MANAGER_MULTI_POP: "GET_VIEWS_DEPT_MANAGER_MULTI_POP", //* 공동사용자 추가 팝업 ON/OFF 가져오기
  GET_VIEWS_ALERT: "GET_VIEWS_ALERT", //* 알림창 ON/OFF 가져오기
  GET_VIEWS_CONFIRM: "GET_VIEWS_CONFIRM", //* 알림창 ON/OFF 가져오기
  GET_VIEWS_LINEAR: "GET_VIEWS_LINEAR", //* 리니어 스피너 ON/OFF 가져오기
  GET_VIEWS_SPINNER: "GET_VIEWS_SPINNER", //* 로딩 스피너 ON/OFF 가져오기
  GET_ERROR: "GET_ERROR", //* 에러 가져오기
  GET_ALERT_DATA: "GET_ALERT_DATA", //* ALERT DATA 가져오기
  GET_CONFIRM_DATA: "GET_CONFIRM_DATA", //* ALERT DATA 가져오기
  GET_USER_DATA: "GET_USER_DATA", //* 사용자 정보 가져오기
  GET_YEAR_LIST: "GET_YEAR_LIST", //* 조회년도 리스트 조회
  GET_SELECTED_YEAR_DATA: "GET_SELECTED_YEAR_DATA", //* 선택한 조회년도 가져오기
  GET_SELECTED_MONTH_DATA: "GET_SELECTED_MONTH_DATA", //* 선택한 조회월 가져오기
  GET_I18N_LIST: "GET_I18N_LIST", //* 다국어 리스트 가져오기
  GET_LANGAGE_CODE_LIST: "GET_LANGAGE_CODE_LIST", //* 언어 코드 가져오기
  GET_COM_KPI_POOL_LIST: "GET_COM_KPI_POOL_LIST", //* KPI POOL 리스트 가져오기
  GET_SELECTED_COM_KPI_POOL_LIST: "GET_SELECTED_COM_KPI_POOL_LIST", //*선택한 KPI 가져오기
  GET_ASSIGNMENT_INFO: "GET_ASSIGNMENT_INFO", //* 과제 정보 가져오기
  GET_PROJECT_HELP_INFO: "GET_PROJECT_HELP_INFO", //* 과제 도움말 정보가져오기
  GET_VIEWS_PRJ_HELP_POP: "GET_VIEWS_PRJ_HELP_POP", //* 과제 도움말 팝업 ON/OFF 가져오기
  GET_SEARCH_ASSIGNMENT_INFO: "GET_SEARCH_ASSIGNMENT_INFO", //* 검색 과제 정보 가져오기
  GET_VIEWS_ASSIGNMENT_SEARCH_POPUP: "GET_VIEWS_ASSIGNMENT_SEARCH_POPUP", //* 과제 검색 팝업 ON/OFF 가져오기
  GET_VIEWS_KPI_POOL_POP: "GET_VIEWS_KPI_POOL_POP", //* 전체 KPI 목록 팝업 ON/OFF 설정
  GET_DEPARTMENT_MANAGER_SRCH_PARAM: "GET_DEPARTMENT_MANAGER_SRCH_PARAM", //* 팝업 ON시 설정한 PARAMETER 값 가져오기
  GET_STRATEGY_SEARCH_POPUP: "GET_STRATEGY_SEARCH_POPUP", //* 전략과제 검색 팝업 ON/OFF 가져오기
  GET_SEARCH_STRATEGY_LIST: "GET_SEARCH_STRATEGY_LIST", //* 검색한 전략과제 리스트 가져오기
  GET_SELECTED_STRATEGY_LIST: "GET_SELECTED_STRATEGY_LIST", //* 선택한 전략과제 정보 가져오기
  GET_COM_KPI_CHART_GRP_LIST: "GET_COM_KPI_CHART_GRP_LIST", //* KPI 차트그룹 목록 가져오기
  GET_SELECTED_CHART_GRP_LIST: "GET_SELECTED_CHART_GRP_LIST", //* 공통 KPI차트그룹 다중 검색팝업에서 선택한 데이터 가져오기
  GET_SELECTED_CHART_GRP: "GET_SELECTED_CHART_GRP", //* 공통 KPI차트그룹 단일 검색팝업에서 선택한 데이터 가져오기
  GET_VIEWS_KPI_CHART_GRP_MULTI_POP: "GET_VIEWS_KPI_CHART_GRP_MULTI_POP", //* KP 차트그룹 목록 팝업 ON/OFF 설정
  GET_VIEWS_KPI_CHART_GRP_SINGLE_POP: "GET_VIEWS_KPI_CHART_GRP_SINGLE_POP", //* KP 차트그룹 목록 단일 선택 팝업 ON/OFF 설정
  GET_VIEWS_DRAW_CHART_POP: "GET_VIEWS_DRAW_CHART_POP", //* 공통 KPI차트그룹 차트 보기 팝업 ON/OFF 설정
  GET_COM_CHART_GRP_DATA: "GET_COM_CHART_GRP_DATA", //* KPI 차트그룹 정보 가져오기
  GET_COM_CHART_KPI_DATA: "GET_COM_CHART_KPI_DATA", //* KPI 차트그룹 별 KPI 실적 가져오기
  GET_COM_CHART_KPI_LIST: "GET_COM_CHART_KPI_LIST", //* KPI 차트그룹 리스트 KPI 실적 가져오기
  GET_VIEWS_COM_SRCH_DEPT_POPUP: "GET_VIEWS_COM_SRCH_DEPT_POPUP", //* 공통 부서 검색 팝업 ON/OFF 가져오기
  GET_COM_DEPT_LIST: "GET_COM_DEPT_LIST", //* 공통 부서 검색 리스트 저장하기
  GET_SELECTED_DEPT: "GET_SELECTED_DEPT", //* 선택된 부서 기져오기
  GET_IS_COM_DEPT_LIST_INNER_GRPS: "GET_IS_COM_DEPT_LIST_INNER_GRPS", //* 공통 부서 호출 전략과제 유무 ON/ OFF
  GET_LOW_DEPT_INFO: "GET_LOW_DEPT_INFO", //* 하위 부서 정보 가져오기
  GET_DEPARTMENT_MANAGER_EDITOR_ID: "GET_DEPARTMENT_MANAGER_EDITOR_ID", //* 트리 리스트 에디터 용
  GET_FILE_INFO_LIST: "GET_FILE_INFO_LIST", //* 파일 리스트 가져오기
  GET_LOW_DEPT_INFO_LIST: "GET_LOW_DEPT_INFO_LIST", //* 하위부서 리스트 가져오기
  GET_I18N_LOCALE: "GET_I18N_LOCALE", //* 다국어 언어설정 가져오기
  GET_ALARM_LIST: "GET_ALARM_LIST", //* 알람 목록 가져오기
  GET_VIEWS_KPI_PERFORMANCE: "GET_VIEWS_KPI_PERFORMANCE", //* KPI 실적보고 ON/OFF 가져오기
  GET_SELECTED_MBO_KPI: "GET_SELECTED_MBO_KPI", //* MBO화면에서 선택된 KPI
  GET_COM_HIGH_LEV_USER_LIST: "GET_COM_HIGH_LEV_USER_LIST", //* 상위레벨 사용자 조회
  GET_VIEWS_NOTICE_POPUP: "GET_VIEWS_NOTICE_POPUP", //* 공지사항 ON/OFF 가져오기
  GET_SEARCH_DEPT_USER_NAME: "GET_SEARCH_DEPT_USER_NAME", //* 사용자 검색용 TXT 저장
  GET_DSB_NOTICE_LIST: "GET_DSB_NOTICE_LIST", //* 대시보드 공지사항 목록 가져오기
  GET_OVERLAY_CLICK_EVENT_HANDLER: "GET_OVERLAY_CLICK_EVENT_HANDLER", //* 오버레이 이벤트 핸들러
  GET_PRJ_DELETE_AVBL: "GET_PRJ_DELETE_AVBL", //* 과제 삭제 가능 여부 조회
  GET_EXIST_KPI_LIST: "GET_EXIST_KPI_LIST", //* 지표 그래프 기존 KPI데이터 저장
  GET_BU_INFO: "GET_BU_INFO", //* 전략체계도 BU 정보
  GET_SELECTED_COUNTRY_CODE: "GET_SELECTED_COUNTRY_CODE", //*선택한 국가코드 가져오기
  GET_TOGGLE_SHOW_HIDE: "GET_TOGGLE_SHOW_HIDE" //*성과 리뷰  - KPI, 차트 TOGGLE
};

//? ACTION CONSTANT
export const actions = {
  // TODO: FETCH CONSTANT DECLARATION
  FETCH_COM_CODE_LIST: "FETCH_COM_CODE_LIST",
  FETCH_COM_USER_INFO: "FETCH_COM_USER_INFO", //* 사용자정보 데이터가져오기
  FETCH_ROLE_LIST: "FETCH_ROLE_LIST",
  FETCH_DEPARTMENT_MANAGER_LIST: "FETCH_DEPARTMENT_MANAGER_LIST", //*담당자/담당부서 리스트 조회
  FETCH_YEAR_LIST: "FETCH_YEAR_LIST", //* 조회년도 리스트 조회
  FETCH_COM_KPI_POOL_LIST: "FETCH_COM_KPI_POOL_LIST", //* KPI POOL 리스트 가져오기
  FETCH_ASSIGNMENT_LIST: "FETCH_ASSIGNMENT_INFO", //* 과제 리스트 가져오기
  FETCH_SEARCH_ASSIGNMENT_LIST: "FETCH_SEARCH_ASSIGNMENT_LIST", //* 검색 과제 리스트 가져오기
  FETCH_COM_DEPT_LIST: "FETCH_COM_DEPT_LIST", //* 공통 부서 검색 리스트 불러오기
  FETCH_LOW_DEPT_INFO: "FETCH_LOW_DEPT_INFO", //* 하위 부서정보 가져오기
  FETCH_SEARCH_STRATEGY_LIST: "FETCH_SEARCH_STRATEGY_LIST", //* 전략과제 검색 가져오기
  FETCH_FILE_INFO_LIST: "FETCH_FILE_INFO_LIST", //* 파일 리스트 가져오기
  FETCH_LOW_DEPT_INFO_LIST: "FETCH_LOW_DEPT_INFO_LIST", //* 하위부서 리스트 가져오기
  FETCH_COM_KPI_CHART_GRP_LIST: "FETCH_COM_KPI_CHART_GRP_LIST", //* KPI 차트그룹 목록 가져오기
  FETCH_COM_CHART_KPI_DATA: "FETCH_COM_CHART_KPI_DATA", //* KPI 차트그룹 별 KPI 실적 가져오기
  FETCH_COM_CHART_KPI_LIST: "FETCH_COM_CHART_KPI_LIST", //* KPI 차트그룹 리스트 KPI 실적 가져오기
  FETCH_ALARM_LIST: "FETCH_ALARM_LIST", //* 알람 목록 불러오기
  FETCH_COM_HIGH_LEV_USER_LIST: "FETCH_COM_HIGH_LEV_USER_LIST", //* 상위레벨 사용자 조회
  FETCH_DSB_NOTICE_LIST: "FETCH_DSB_NOTICE_LIST", //* 대시보드 공지사항 목록 조회
  FETCH_PRJ_DELETE_AVBL: "FETCH_PRJ_DELETE_AVBL", //* 과제 삭제 가능 여부 조회
  FETCH_BU_INFO: "FETCH_BU_INFO", //* 전략체계도 BU 정보

  // TODO: INSERT CONSTANT DECLARATION

  // TODO: UPDATE CONSTANT DECLARATION
  UPDATE_ALARM_READ: "UPDATE_ALARM_READ", //* 알람 읽은 날짜 업데이트
  DELETE_ALARM: "DELETE_ALARM", //* 알람 읽은 상태로 수정
  // TODO: DELETE CONSTANT DECLARATION

  // TODO: INIT CONSTANT DECLARATION
  INIT_DEPARTMENT_MANAGER_LIST: "INIT_DEPARTMENT_MANAGER_LIST", //*담당자/담당부서 리스트 세팅
  INIT_SELECTED_DEPARTMENT_MANAGER_DATA: "INIT_SELECTED_DEPARTMENT_MANAGER_DATA", //* 선택한 담당부서/담당자 데이터 세팅
  INIT_SELECTED_DEPARTMENT_MANAGER_LIST: "INIT_SELECTED_DEPARTMENT_MANAGER_LIST", //* 선택한 담당부서/담당자 데이터(다중) 세팅
  INIT_VIEWS_DEPT_MANAGER_SINGLE_POP: "INIT_VIEWS_DEPT_MANAGER_SINGLE_POP", //* 담당부서/담당자 (싱글선택) 팝업 ON/OFF 설정
  INIT_VIEWS_DEPT_MANAGER_MULTI_POP: "INIT_VIEWS_DEPT_MANAGER_MULTI_POP", //* 담당부서/담당자(멀티선택) 팝업 ON/OFF 설정
  INIT_DEPARTMENT_MANAGER_SRCH_PARAM: "INIT_DEPARTMENT_MANAGER_SRCH_PARAM", //* 팝업 ON시 설정한 PARAMETER 값 설정
  INIT_EXIST_KPI_LIST: "INIT_EXIST_KPI_LIST", //* 지표 그래프 기존 KPI데이터 저장

  INIT_VIEWS_ALERT: "INIT_VIEWS_ALERT", //* 알림창 ON/OFF 설정
  INIT_VIEWS_CONFIRM: "INIT_VIEWS_CONFIRM", //* CONFIRM ON/OFF 설정
  INIT_VIEWS_LINEAR: "INIT_VIEWS_LINEAR", //* 리니어 스피너 ON/OFF 설정
  INIT_VIEWS_SPINNER: "INIT_VIEWS_SPINNER", //* 로딩 스피너 ON/OFF 가져오기
  INIT_YEAR_LIST: "INIT_YEAR_LIST", //* 조회년도 리스트 세팅
  INIT_SELECTED_YEAR_DATA: "INIT_SELECTED_YEAR_DATA", //* 선택한 조회년도 세팅
  INIT_SELECTED_MONTH_DATA: "INIT_SELECTED_MONTH_DATA", //* 선택한 조회월 세팅
  INIT_SELECTED_COM_KPI_POOL_LIST: "INIT_SELECTED_COM_KPI_POOL_LIST", //*선택한 KPI세팅

  INIT_ASSIGNMENT_INFO: "INIT_ASSIGNMENT_INFO", //* 선택한 과제 정보 초기화
  INIT_SEARCH_ASSIGNMENT_INFO: "INIT_SEARCH_ASSIGNMENT_INFO", //* 검색 과제 정보 초기화
  INIT_PROJECT_HELP_INFO: "INIT_PROJECT_HELP_INFO", //* 과제 도움말 정보가져오기
  INIT_VIEWS_PRJ_HELP_POP: "INIT_VIEWS_PRJ_HELP_POP", //* 과제 도움말 팝업 ON/OFF 초기화
  INIT_VIEWS_ASSIGNMENT_SEARCH_POPUP: "INIT_VIEWS_ASSIGNMENT_SEARCH_POPUP", //* 과제 검색 팝업(다수) ON/OFF 설정
  INIT_STRATEGY_SEARCH_POPUP: "INIT_STRATEGY_SEARCH_POPUP", //* 전략과제 검색 팝업 ON/OFF 초기화
  INIT_SEARCH_STRATEGY_LIST: "INIT_SEARCH_STRATEGY_LIST", //* 검색한 전략과제 리스트 초기화
  INIT_SELECTED_STRATEGY_LIST: "INIT_SELECTED_STRATEGY_LIST", //* 선택한 전략과제 정보 초기화

  INIT_VIEWS_KPI_POOL_POP: "INIT_VIEWS_KPI_POOL_POP", //* 전체 KPI 목록 팝업 ON/OFF 설정
  INIT_VIEWS_KPI_CHART_GRP_MULTI_POP: "INIT_VIEWS_KPI_CHART_GRP_MULTI_POP", //* KP 차트그룹 목록 다중 선택 팝업 ON/OFF 설정
  INIT_VIEWS_KPI_CHART_GRP_SINGLE_POP: "INIT_VIEWS_KPI_CHART_GRP_SINGLE_POP", //* KP 차트그룹 목록 단일 선택 팝업 ON/OFF 설정
  INIT_SELECTED_CHART_GRP_LIST: "INIT_SELECTED_CHART_GRP_LIST", //* 공통 KPI차트그룹 다중 검색팝업에서 선택한 데이터 저장
  INIT_SELECTED_CHART_GRP: "INIT_SELECTED_CHART_GRP", //* 공통 KPI차트그룹 단일 검색팝업에서 선택한 데이터 저장
  INIT_COM_KPI_CHART_GRP_LIST: "INIT_COM_KPI_CHART_GRP_LIST", //* 공통 KPI차트그룹 데이터 초기화
  INIT_VIEWS_DRAW_CHART_POP: "INIT_VIEWS_DRAW_CHART_POP", //* 공통 KPI차트그룹 차트 보기 팝업 ON/OFF 설정
  INIT_COM_CHART_GRP_DATA: "INIT_COM_CHART_GRP_DATA", //* KPI 차트그룹 정보 저장

  INIT_VIEWS_COM_SRCH_DEPT_POPUP: "INIT_VIEWS_COM_SRCH_DEPT_POPUP", //* 공통 부서 검색 팝업 ON/OFF 설정
  INIT_SELECTED_DEPT: "INIT_SELECTED_DEPT", //* 선택된 부서 초기화
  INIT_IS_COM_DEPT_LIST_INNER_GRPS: "INIT_IS_COM_DEPT_LIST_INNER_GRPS", //* 공통 부서 호출 전략과제 유무 ON/ OFF 초기화
  INIT_LOW_DEPT_INFO: "INIT_LOW_DEPT_INFO", //* 나의 하위 부서정보 초기화
  INIT_DEPARTMENT_MANAGER_EDITOR_ID: "INIT_DEPARTMENT_MANAGER_EDITOR_ID", //* 트리 리스트 에디터 체크용
  INIT_FILE_INFO_LIST: "INIT_FILE_INFO_LIST", //* 파일 리스트 초기화
  INIT_LOW_DEPT_INFO_LIST: "INIT_LOW_DEPT_INFO_LIST", //* 하위부서 리스트 초기화
  INIT_I18N_LOCALE: "INIT_I18N_LOCALE", //* 다국어 언어설정 초기화
  INIT_I18N_LIST: "INIT_I18N_LIST", //* 다국어 리스트 초기화
  INIT_COM_USER_INFO: "INIT_COM_USER_INFO", //* 사용자정보 초기화
  INIT_VIEWS_KPI_PERFORMANCE: "INIT_VIEWS_KPI_PERFORMANCE", //* KPI 실적보고 ON/OFF 초기화
  INIT_SELECTED_MBO_KPI: "INIT_SELECTED_MBO_KPI", //* MBO화면에서 선택된 KPI 초기화
  INIT_VIEWS_NOTICE_POPUP: "INIT_VIEWS_NOTICE_POPUP", //* 공지사항 팝업 ON/OFF 초기화

  INIT_SEARCH_DEPT_USER_NAME: "INIT_SEARCH_DEPT_USER_NAME", //* 사용자 명 검색용 TXT 초기화
  INIT_OVERLAY_CLICK_EVENT_HANDLER: "INIT_OVERLAY_CLICK_EVENT_HANDLER", //* 오버레이 이벤트 핸들러

  INIT_SELECTED_COUNTRY_CODE: "INIT_SELECTED_COUNTRY_CODE", //*선택한 국가코드 세팅
  INIT_TOGGLE_SHOW_HIDE: "INIT_TOGGLE_SHOW_HIDE" //*성과 리뷰  - KPI, 차트 TOGGLE
};

//? MUTATIONS CONSTANT
export const mutations = {
  // TODO: SET CONSTANT DECLARATION
  SET_MENU_LIST: "SET_MENU_LIST",
  SET_MESSAGE_LIST: "SET_MESSAGE_LIST",
  SET_VIEWS_SPINNER: "SET_VIEWS_SPINNER",
  SET_APP_BAR: "SET_APP_BAR",
  SET_COM_CODE_LIST: "SET_COM_CODE_LIST",
  SET_COM_USER_INFO: "GET_COM_USER_INFO", //* 사용자정보 데이터셋팅
  SET_ROLE_LIST: "SET_ROLE_LIST",
  SET_SELECTED_DEPARTMENT_MANAGER_DATA: "SET_SELECTED_DEPARTMENT_MANAGER_DATA", //* 선택한 담당부서/담당자 데이터 세팅
  SET_SELECTED_DEPARTMENT_MANAGER_LIST: "SET_SELECTED_DEPARTMENT_MANAGER_LIST", //* 선택한 담당부서/담당자 데이터(다중)세팅
  SET_DEPARTMENT_MANAGER_LIST: "SET_DEPARTMENT_MANAGER_LIST", //* 담당자/담당부서 리스트 세팅
  SET_VIEWS_DEPT_MANAGER_SINGLE_POP: "SET_VIEWS_DEPT_MANAGER_SINGLE_POP", //* 담당부서/담당자 팝업 ON/OFF 설정
  SET_VIEWS_DEPT_MANAGER_MULTI_POP: "SET_VIEWS_DEPT_MANAGER_MULTI_POP", //* 공동사용자 추가 팝업 ON/OFF 설정
  SET_VIEWS_ALERT: "SET_VIEWS_ALERT", //* 알림창 ON/OFF 설정
  SET_VIEWS_CONFIRM: "SET_VIEWS_CONFIRM", //* CONFIRM ON/OFF 설정
  SET_VIEWS_LINEAR: "SET_VIEWS_LINEAR", //* 리니어 스피너 ON/OFF 설정
  SET_YEAR_LIST: "SET_YEAR_LIST", //* 조회년도 리스트 세팅
  SET_SELECTED_YEAR_DATA: "SET_SELECTED_YEAR_DATA", //* 선택한 조회년도 세팅
  SET_SELECTED_MONTH_DATA: "SET_SELECTED_MONTH_DATA", //* 선택한 조회월 세팅
  SET_LANGAGE_CODE_LIST: "SET_LANGAGE_CODE_LIST", //* 언어 코드 저장
  SET_COM_KPI_POOL_LIST: "SET_COM_KPI_POOL_LIST", //* KPI POOL 리스트 세팅
  SET_SELECTED_COM_KPI_POOL_LIST: "SET_SELECTED_COM_KPI_POOL_LIST", //*선택한 KPI세팅
  SET_PROJECT_HELP_INFO: "SET_PROJECT_HELP_INFO", //* 과제 도움말 정보 저장
  SET_VIEWS_PRJ_HELP_POP: "SET_VIEWS_PRJ_HELP_POP", //* 과제 도움말 팝업 ON/OFF 저장
  SET_ASSIGNMENT_INFO: "SET_ASSIGNMENT_INFO", //* 과제정보 저장
  SET_SEARCH_ASSIGNMENT_INFO: "SET_SEARCH_ASSIGNMENT_INFO", //* 검색 과제정보 저장
  SET_VIEWS_ASSIGNMENT_SEARCH_POPUP: "SET_VIEWS_ASSIGNMENT_SEARCH_POPUP", //* 과제 검색 팝업 ON/OFF 설정
  SET_VIEWS_KPI_POOL_POP: "SET_VIEWS_KPI_POOL_POP", //* 전체 KPI 목록 팝업 ON/OFF 설정
  SET_DEPARTMENT_MANAGER_SRCH_PARAM: "SET_DEPARTMENT_MANAGER_SRCH_PARAM", //* 팝업 ON시 설정한 PARAMETER 값 설정
  SET_STRATEGY_SEARCH_POPUP: "SET_STRATEGY_SEARCH_POPUP", //* 전략과제 검색 팝업 ON/OFF 저장
  SET_SEARCH_STRATEGY_LIST: "SET_SEARCH_STRATEGY_LIST", //* 검색한 전략과제 리스트 저장
  SET_SELECTED_STRATEGY_LIST: "SET_SELECTED_STRATEGY_LIST", //* 선택한 전략과제 정보 초기화
  SET_COM_KPI_CHART_GRP_LIST: "SET_COM_KPI_CHART_GRP_LIST", //* KPI 차트그룹 목록 저장
  SET_SELECTED_CHART_GRP_LIST: "SET_SELECTED_CHART_GRP_LIST", //* 공통 KPI차트그룹 다중 검색팝업에서 선택한 데이터 저장
  SET_SELECTED_CHART_GRP: "SET_SELECTED_CHART_GRP", //* 공통 KPI차트그룹 단일 검색팝업에서 선택한 데이터 저장
  SET_VIEWS_KPI_CHART_GRP_MULTI_POP: "SET_VIEWS_KPI_CHART_GRP_MULTI_POP", //* KP 차트그룹 목록 팝업 ON/OFF 설정
  SET_VIEWS_KPI_CHART_GRP_SINGLE_POP: "SET_VIEWS_KPI_CHART_GRP_SINGLE_POP", //* KP 차트그룹 목록 단일 선택 팝업 ON/OFF 설정
  SET_VIEWS_DRAW_CHART_POP: "SET_VIEWS_DRAW_CHART_POP", //* 공통 KPI차트그룹 차트 보기 팝업 ON/OFF 설정
  SET_COM_CHART_GRP_DATA: "SET_COM_CHART_GRP_DATA", //* KPI 차트그룹 정보 저장
  SET_COM_CHART_KPI_DATA: "SET_COM_CHART_KPI_DATA", //* KPI 차트그룹 별 KPI 실적 저장
  SET_COM_CHART_KPI_DATA_LIST: "SET_COM_CHART_KPI_DATA_LIST", //* KPI 차트그룹 리스트 KPI 실적 저장
  SET_VIEWS_COM_SRCH_DEPT_POPUP: "SET_VIEWS_COM_SRCH_DEPT_POPUP", //* 공통 부서 검색 팝업 ON/OFF 저장하기
  SET_COM_DEPT_LIST: "SET_COM_DEPT_LIST", //* 공통 부서 검색 리스트 가져오기
  SET_SELECTED_DEPT: "SET_SELECTED_DEPT", //* 선택된 부서 설정
  SET_IS_COM_DEPT_LIST_INNER_GRPS: "SET_IS_COM_DEPT_LIST_INNER_GRPS", //* 공통 부서 호출 전략과제 유무 ON/ OFF 저장
  SET_LOW_DEPT_INFO: "SET_LOW_DEPT_INFO", //* 하위 부서정보 저장
  SET_DEPARTMENT_MANAGER_EDITOR_ID: "SET_DEPARTMENT_MANAGER_EDITOR_ID", //* 트리 리스트 에디터용
  SET_FILE_INFO_LIST: "SET_FILE_INFO_LIST", //* 파일 리스트 세팅
  SET_LOW_DEPT_INFO_LIST: "SET_LOW_DEPT_INFO_LIST", //* 하위부서 리스트 세팅
  SET_I18N_LOCALE: "SET_I18N_LOCALE", //* 다국어 언어설정 저장하기
  SET_I18N_LIST: "SET_I18N_LIST", //* 다국어 리스트 저장
  SET_ALARM_LIST: "SET_ALARM_LIST", //* 알람 목록 저장
  SET_VIEWS_KPI_PERFORMANCE: "SET_VIEWS_KPI_PERFORMANCE", //* KPI 실적보고 ON/OFF 저장
  SET_SELECTED_MBO_KPI: "SET_SELECTED_MBO_KPI", //* MBO화면에서 선택된 KPI 저장
  SET_COM_HIGH_LEV_USER_LIST: "SET_COM_HIGH_LEV_USER_LIST", //* 상위레벨 사용자 조회
  SET_VIEWS_NOTICE_POPUP: "SET_VIEWS_NOTICE_POPUP", //* 공지사항 ON/OFF 저장
  SET_SEARCH_DEPT_USER_NAME: "SET_SEARCH_DEPT_USER_NAME", //* 사용자 검색용 TXT 저장
  SET_DSB_NOTICE_LIST: "SET_DSB_NOTICE_LIST", //* 대시보드 공지사항 목록 저장
  SET_OVERLAY_CLICK_EVENT_HANDLER: "SET_OVERLAY_CLICK_EVENT_HANDLER", //* 오버레이 이벤트 핸들러
  SET_PRJ_DELETE_AVBL: "SET_PRJ_DELETE_AVBL", //* 과제 삭제 가능 여부 조회
  SET_EXIST_KPI_LIST: "SET_EXIST_KPI_LIST", //* 지표 그래프 기존 KPI데이터 저장
  SET_BU_INFO: "SET_BU_INFO", //* 전략체계도 BU 정보
  SET_SELECTED_COUNTRY_CODE: "SET_SELECTED_COUNTRY_CODE", //*선택한 국가코드 세팅
  SET_TOGGLE_SHOW_HIDE: "SET_TOGGLE_SHOW_HIDE" //*성과 리뷰  - KPI, 차트 TOGGLE
};

//* ROOT ACTIONS CONSTANT
export const rootActions = {
  ...Object.entries(actions).reduce((acc, cur) => {
    acc[cur[0]] = `common/${cur[1]}`;
    return acc;
  }, {})
};

//* ROOT MUTATIONS CONSTANT
export const rootMutations = {
  ...Object.entries(mutations).reduce((acc, cur) => {
    acc[cur[0]] = `common/${cur[1]}`;
    return acc;
  }, {})
};
